module.exports = __webpack_public_path__ + "static/media/Finneon_gaussian2.8cb877ae.png";